module.exports = __webpack_public_path__ + "img/big.ff08f383.jpg";